/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconForbid2 = createReactComponent("forbid-2", "IconForbid2", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M9 15l6 -6", key: "svg-1" }]
]);

export { IconForbid2 as default };
//# sourceMappingURL=IconForbid2.js.map
